import {Component, Input, Output, EventEmitter, TemplateRef} from '@angular/core';

@Component({
  selector: 'app-form-bloc',
  templateUrl: './form-bloc.component.html',
  styleUrls: ['./form-bloc.component.scss'],
})
export class FormBlocComponent {
  @Input() titre: string;
  @Input() subtitle: string;
  @Input() titreSpotLight: string;
  @Input() alterTitre: string;
  @Input() actions: TemplateRef<any>;
  @Input() buttonAddEnabled: boolean;
  @Input() buttonAddTitle: string;
  @Input() buttonExportEnabled: boolean;
  @Input() buttonExportTitle: string;
  @Input() buttonNavigateEnabled: boolean;
  @Input() afficherTitrePrincipal = true;
  @Input() hidden = false;
  @Input() ngIfBloc = true;
  @Input() haveContent = true;

  @Output() buttonAddClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() buttonExportClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() buttonNavigateClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() afficherTitrePrincipalChange = new EventEmitter<boolean>();

  alterTitreSelectionne(): boolean {
    return !this.afficherTitrePrincipal;
  }

  selectionnerTitreAlternatif() {    
    this.afficherTitrePrincipal = false;
    this.afficherTitrePrincipalChange.emit(false);
  }

  selectionnerTitrePrincipal() {
    this.afficherTitrePrincipal = true;
    this.afficherTitrePrincipalChange.emit(true);
  }

  get hasTitleSelection(): boolean {
    return (this.alterTitre != null);
  }

  addClick(): void {
    this.buttonAddClick.emit();
  }

  exportClick(): void {
    this.buttonExportClick.emit();
  }

  navigateClick(): void {
    this.buttonNavigateClick.emit();
  }
}
